import { render, staticRenderFns } from "./TicketAuthorizations.vue?vue&type=template&id=370a3e4a&scoped=true&"
import script from "./TicketAuthorizations.vue?vue&type=script&lang=js&"
export * from "./TicketAuthorizations.vue?vue&type=script&lang=js&"
import style0 from "./TicketAuthorizations.vue?vue&type=style&index=0&id=370a3e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a3e4a",
  null
  
)

export default component.exports